// extracted by mini-css-extract-plugin
export default {"Dashboard":"dashboard_Dashboard__xpnFU","singleInfo":"dashboard_singleInfo__TsWK9","Count":"dashboard_Count__B9tWs","mobileRemove":"dashboard_mobileRemove__Pclan"};